// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1shwG","location":"Header_location__1FXwb"};